import { DayPickerOptions } from './types';

const days: DayPickerOptions = [
  { value: 'Monday', label: 'M' },
  { value: 'Tuesday', label: 'T' },
  { value: 'Wednesday', label: 'W' },
  { value: 'Thursday', label: 'Th' },
  { value: 'Friday', label: 'F' },
  { value: 'Saturday', label: 'S' },
  { value: 'Sunday', label: 'S' },
];

export const defaultConfig = { allowDisabledSelectedState: true, options: days, onDayToggle: () => {} };
export { days as DayPickerDays };
